import React, { Component } from "react"
import { connect } from "react-redux"
import styled from "styled-components"
import { withRouter, Link } from "react-router-dom"
import { message } from "antd";
import { withFormik } from "formik"
import { Form, Input, SubmitButton } from "formik-antd"
import Auth from "src/ducks/Auth"
import FormField from "src/shared/FormField"
import { Icon } from 'src/shared/LegacyIcon'

const FormIcon = styled(Icon)`
  color: rgba(0, 0, 0, 0.25);
`

class CompleteForm extends Component {
  render() {
    const { handleSubmit } = this.props

    return (
      <Form onSubmit={handleSubmit}>
        <FormField name="password" label="Enter a password">
          <Input
            size="large"
            prefix={<FormIcon type="lock" />}
            placeholder="Password"
            type="password"
          />
        </FormField>
        <SubmitButton size="large" type="primary" disabled={false} block>
          Go to Dashboard
        </SubmitButton>
        Or <Link to="/sign_in">Login</Link>
      </Form>
    )
  }
}

const EnhancedCompleteForm = withFormik({
  mapPropsToValues: () => ({ password: "" }),

  validate: (values) => {
    const errors = {}

    if (!values.password) {
      errors.password = "Fill in a password"
    }

    return errors
  },

  handleSubmit: (values, { props, setSubmitting, setErrors }) => {
    props
      .updateUser({
        ...values,
        confirmation_token: props.confirmationToken
      })
      .then(() => {
        props.history.push("/")
        setSubmitting(false)
      })
      .catch((res) => {
        message.error("Failed to update account")
        setErrors(res.response.data.meta.errors)
        setSubmitting(false)
      })
  },

  displayName: "CompleteForm"
})(CompleteForm)

const mapStateToProps = (state) => ({})

const mapDispatchToProps = {
  updateUser: Auth.updateUser
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(EnhancedCompleteForm))
